<template>
  <div 
    v-if="visible"
    class="h-screen w-screen z-[9999] fixed left-0 loader-bg"
  >
    <div class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col items-center w-full">
       <p class="font-medium text-lg text-center ">{{ description || 'Please wait...' }}</p>
        <img      
          :src="'/img/survey-loader.gif'"
          alt="Please wait..."   
          class=""         
        />
    </div>
   
  </div>
</template>

<script lang="ts" setup>
  defineProps<{ 
    visible: boolean 
    description?: string
  }>()
</script>

<style>
  .loader-bg{
    background: rgba(232, 241, 255);;
  }
</style>